import { gql } from '@apollo/client';

const GET_FILE_POST_URLS_MUTATION = gql`
  mutation GetFilePostUrls(
    $parentId: ID
    $fileType: FileType!
    $fileName: String!
    $contentType: String!
    $assetClass: AssetClass
    $productType: ProductType
    $qmMode: QMMode
  ) {
    getFilePostUrl(
      parentId: $parentId
      fileType: $fileType
      fileName: $fileName
      contentType: $contentType
      assetClass: $assetClass
      productType: $productType
      qmMode: $qmMode
    )
  }
`;

export default GET_FILE_POST_URLS_MUTATION;
